module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/Mic-900749efdd2ba1ddfb4fdbecfbce3039c0f8575c3f158dd85cc49a03354a9f18.svg";